module.exports = __webpack_public_path__ + "media/images/pc/icon-star-blank-green-bb963b24f4c6849c86810ff8cdfe1a72.png";